import { styled, Box, clsx } from 'external/material'
import { FC } from 'external/react'

type LeyendProps = {
  colorLeyend: string;
  label: string;
}

const StyledBox = styled(Box)(leyendStyles)

const Leyend: FC<LeyendProps> = (props) => {
  return (
    <StyledBox {...props}>
      <div className={clsx('circle-leyend')}></div>
      <p className={clsx('label-leyend')}>{props.label}</p>
    </StyledBox>
  )
}

function leyendStyles(props: any) {
  const { theme, ...rest } = props
  const { color } = rest

  return {
    display: 'flex', 
    height: '100%', 
    alignItems: 'center', 
    justifyContent: 'center',
    gap: '8px',
    '& .circle-leyend': {
      backgroundColor: color, 
      height: '17px', 
      width: '17px', 
      borderRadius: '100%'
    },
    '& .label-leyend': {
      color: 'rgba(0,0,0,0.5)'
    }
  }
}

export {Leyend as default}